module.exports = __webpack_public_path__ + "img/jason-and-andy.5768196b.jpg";